<template>
    <div class="cart-item"  :class="{ 'hideClass' : hideClass, 'disableClass' : disableClass }">
        <div class="inner">
        <div class="item">
            <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="26.049" height="25.814" viewBox="0 0 26.049 25.814">
                <path id="Path_3761" data-name="Path 3761" d="M5045.045-19485.148c-.527,1.859-.437,6.586-.59,9.594s-.309,11.18.463,12.514,9.044.045,11.858,0,10.585.252,11.111-1.5a25.112,25.112,0,0,0,.321-7.691c-.194-3.16-.042-10.977-1.138-12.578s-8.656-1.031-11.869-1.3S5045.571-19487.008,5045.045-19485.148Z" transform="translate(-5043.273 19487.354)" fill="none" stroke="#101820" stroke-width="2"/>
                </svg>
            </div>
            <el-checkbox v-model="selectItem" @change="selectEvent($event)">
                <div class="checkicon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14.066" height="14.174" viewBox="0 0 14.066 14.174">
                    <g id="Group_1851" data-name="Group 1851" transform="matrix(0.978, 0.208, -0.208, 0.978, -291.853, -423.135)">
                        <path id="Path_218" data-name="Path 218" d="M.426,1.166C2.573.7,4.748,1.208,6.9.912c.547-.075.866-1.005.129-.9C4.876.3,2.706-.2.555.263.02.378-.308,1.325.426,1.166Z" transform="matrix(0.829, 0.559, -0.559, 0.829, 376.489, 359.997)" fill="#101820" stroke="#101820" stroke-width="1"/>
                        <path id="Path_220" data-name="Path 220" d="M12.139.1a12.457,12.457,0,0,1-5,.486C5.169.5,3.2.389,1.255.125.332,0-.669,1.055.6,1.227a56.735,56.735,0,0,0,7.106.5A13.976,13.976,0,0,0,12.973.99C14.133.528,13.094-.281,12.139.1Z" transform="translate(386.839 351.98) rotate(109)" fill="#101820" stroke="#101820" stroke-width="1"/>
                    </g>
                    </svg>
                </div>
            </el-checkbox>
        </div>
        <div class="item">
            <router-link :to="_.get(currentData, 'link')">
            <img :src="_.get(currentData, 'ProductObject.images.0.url')" />
            </router-link>
        </div>
        <div class="item">
            <router-link :to="_.get(currentData, 'link')">
            <p v-if="!_.get(currentData, 'ProductObject.gift')" class="title bold-italic">{{ _.get(currentData, 'ProductObject.title') }}</p>
            <p v-if="$route.name === 'ge'" class="title bold-italic">{{ _.get(currentData, 'ProductObject.title.ge') }}</p>
            <p v-if="$route.name === 'en'" class="title bold-italic">{{ _.get(currentData, 'ProductObject.title.en') }}</p>
            </router-link>
            <p class="size light-italic" :class="{ 'hideClass' : !_.get(currentData, 'size') }">ზომა: <span class="bold-italic">{{ _.get(currentData, 'size') }}</span></p>
        </div>
        </div>
        <div class="inner">
        <div class="item">
            <p class="mount-mob bold-italic">{{ $fn.tr('რაოდენობა') }}</p>
            <button @click="dencrement">
                <svg xmlns="http://www.w3.org/2000/svg" width="19.919" height="5.043" viewBox="0 0 19.919 5.043">
                <path id="Path_219" data-name="Path 219" d="M5.179,22.785c3.466.064,6.869-.624,10.326-.7,2.115-.044,4.418.254,6.483-.368.513-.154,1.145-.451,1.124-1.067l0-.075c-.02-.6-1.129-.575-1.9-.195-1.88.431-4.016.044-5.909.145-3.048.163-6.065.723-9.124.666C5.122,21.175,3.4,22.752,5.179,22.785Z" transform="matrix(-0.998, -0.07, 0.07, -0.998, 22.187, 24.878)" fill="#044b30" stroke="#044b30" stroke-width="1"/>
                </svg>
            </button>
            <p class="counter bold-italic">{{ mount }}</p>
             <button @click="increment">
                <svg xmlns="http://www.w3.org/2000/svg" width="19.919" height="19.711" viewBox="0 0 19.919 19.711">
                <g id="Group_1828" data-name="Group 1828" transform="translate(-1123.776 -866.017)">
                    <path id="Path_219" data-name="Path 219" d="M5.179,22.785c3.466.064,6.869-.624,10.326-.7,2.115-.044,4.418.254,6.483-.368.513-.154,1.145-.451,1.124-1.067l0-.075c-.02-.6-1.129-.575-1.9-.195-1.88.431-4.016.044-5.909.145-3.048.163-6.065.723-9.124.666C5.122,21.175,3.4,22.752,5.179,22.785Z" transform="matrix(-0.998, -0.07, 0.07, -0.998, 1145.963, 898.233)" fill="#044b30" stroke="#044b30" stroke-width="1"/>
                    <path id="Path_3800" data-name="Path 3800" d="M5.179,22.785c3.466.064,6.869-.624,10.326-.7,2.115-.044,4.418.254,6.483-.368.513-.154,1.145-.451,1.124-1.067l0-.075c-.02-.6-1.129-.575-1.9-.195-1.88.431-4.016.044-5.909.145-3.048.163-6.065.723-9.124.666C5.122,21.175,3.4,22.752,5.179,22.785Z" transform="translate(1155.184 862.115) rotate(90)" fill="#044b30" stroke="#044b30" stroke-width="1"/>
                </g>
                </svg>
            </button>
        </div>
        <div class="item-mob">
            <p class="price bold-italic">{{ getPrice.toFixed(2) }} ₾<span class="price-mob bold-italic">{{ $fn.tr('ფასი') }}</span><span class="disable-mob light-italic" v-if="_.get(currentData, 'ProductObject.oldprice')" >{{ _.get(currentData, 'ProductObject.oldprice') }} ₾</span></p>
        </div>
        <div class="item">
            <p class="disable-price" v-if="_.get(currentData, 'ProductObject.oldprice') > 0" >{{ _.get(currentData, 'ProductObject.oldprice') }} ₾</p>
            <p class="price bold-italic">{{ getPrice.toFixed(2) }} ₾<span class="price-mob bold-italic">{{ $fn.tr('ფასი') }}</span><span class="disable-mob light-italic" v-if="_.get(currentData, 'ProductObject.oldprice')" >{{ _.get(currentData, 'ProductObject.oldprice') }} ₾</span></p>
            <button class="delete" @click="deleteItem(_.get(currentData, 'ProductObject.id'))">
                <span class="light-italic">{{ $fn.tr('წაშლა') }}</span>
                <div class="icon">
                    <svg id="Group_1845" data-name="Group 1845" xmlns="http://www.w3.org/2000/svg" width="15" height="18" viewBox="0 0 15 18">
                    <path id="Path_3807" data-name="Path 3807" d="M16.25,3H13.925A3.757,3.757,0,0,0,10.25,0H8.75A3.757,3.757,0,0,0,5.075,3H2.75a.75.75,0,0,0,0,1.5H3.5v9.75A3.755,3.755,0,0,0,7.25,18h4.5a3.755,3.755,0,0,0,3.75-3.75V4.5h.75a.75.75,0,0,0,0-1.5ZM8.75,1.5h1.5A2.254,2.254,0,0,1,12.372,3H6.628A2.254,2.254,0,0,1,8.75,1.5ZM14,14.25a2.25,2.25,0,0,1-2.25,2.25H7.25A2.25,2.25,0,0,1,5,14.25V4.5h9Z" transform="translate(-2)" fill="#101820"/>
                    <path id="Path_3808" data-name="Path 3808" d="M9.75,16a.75.75,0,0,0,.75-.75v-4.5a.75.75,0,0,0-1.5,0v4.5A.75.75,0,0,0,9.75,16Z" transform="translate(-3.75 -2.5)" fill="#101820"/>
                    <path id="Path_3809" data-name="Path 3809" d="M13.75,16a.75.75,0,0,0,.75-.75v-4.5a.75.75,0,0,0-1.5,0v4.5A.75.75,0,0,0,13.75,16Z" transform="translate(-4.75 -2.5)" fill="#101820"/>
                    </svg>
                </div>
                <div class="icon-mob">
                    <svg xmlns="http://www.w3.org/2000/svg" width="42.08" height="25.82" viewBox="0 0 42.08 25.82">
                    <path id="Path_3813" data-name="Path 3813" d="M5045.522-19485.148c-.878,1.859-.729,6.586-.983,9.594s-.515,11.18.771,12.516,15.072.043,19.762,0,17.64.25,18.517-1.5.859-4.541.536-7.691-.07-10.977-1.9-12.578-14.426-1.031-19.779-1.3S5046.4-19487.008,5045.522-19485.148Z" transform="translate(-5043.233 19487.342)" fill="#fff" stroke="#101820" stroke-width="2"/>
                    </svg>
                </div>
            </button>
            <div class="check-mob">
                 <div class="icon">
                <svg xmlns="http://www.w3.org/2000/svg" width="26.049" height="25.814" viewBox="0 0 26.049 25.814">
                <path id="Path_3761" data-name="Path 3761" d="M5045.045-19485.148c-.527,1.859-.437,6.586-.59,9.594s-.309,11.18.463,12.514,9.044.045,11.858,0,10.585.252,11.111-1.5a25.112,25.112,0,0,0,.321-7.691c-.194-3.16-.042-10.977-1.138-12.578s-8.656-1.031-11.869-1.3S5045.571-19487.008,5045.045-19485.148Z" transform="translate(-5043.273 19487.354)" fill="none" stroke="#101820" stroke-width="2"/>
                </svg>
            </div>
            <el-checkbox v-model="selectItem">
                <div class="checkicon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="14.066" height="14.174" viewBox="0 0 14.066 14.174">
                    <g id="Group_1851" data-name="Group 1851" transform="matrix(0.978, 0.208, -0.208, 0.978, -291.853, -423.135)">
                        <path id="Path_218" data-name="Path 218" d="M.426,1.166C2.573.7,4.748,1.208,6.9.912c.547-.075.866-1.005.129-.9C4.876.3,2.706-.2.555.263.02.378-.308,1.325.426,1.166Z" transform="matrix(0.829, 0.559, -0.559, 0.829, 376.489, 359.997)" fill="#101820" stroke="#101820" stroke-width="1"/>
                        <path id="Path_220" data-name="Path 220" d="M12.139.1a12.457,12.457,0,0,1-5,.486C5.169.5,3.2.389,1.255.125.332,0-.669,1.055.6,1.227a56.735,56.735,0,0,0,7.106.5A13.976,13.976,0,0,0,12.973.99C14.133.528,13.094-.281,12.139.1Z" transform="translate(386.839 351.98) rotate(109)" fill="#101820" stroke="#101820" stroke-width="1"/>
                    </g>
                    </svg>
                </div>
            </el-checkbox>
            </div>
        </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        currentData: {
            required: true,
        },
    },
    data() {
        return {
            staticMount: _.get(this.currentData, 'mount'),
            selectItem: true,
            elemID: _.get(this.currentData, 'ProductObject.id'),
            hiddenElem: null,
            mount: _.get(this.currentData, 'mount'),
            incrementChange: false,
            disableClass: false,
            hideClass: false,
            productClone: [...this.$store.state.main.productClone],
            num: null,
        }
    },
    computed: {
        returnMount() {
            return this.mount
        },
        // selectEvent() {
        //     return this.selectItem
        // },
        getStaitcPrice() {
            return _.get(this.currentData, 'ProductObject.price')
        },
        getPrice() {
            if (this.incrementChange) {
                return this.num = parseFloat(_.get(this.currentData, 'ProductObject.price')) * this.mount
            } else if (this.incrementChange === null) {
                return this.num = parseFloat(_.get(this.currentData, 'ProductObject.price')) * this.mount
            }
            else {
                this.num = parseFloat(_.get(this.currentData, 'ProductObject.price')) * _.get(this.currentData, 'mount')
                return this.num
            }
        }
    },
    // emits: ['delete-item'],
    // emits: ['emit-balance'],
    mounted() {
        this.$store.state.main.zero = false
    },
    // watch: {
    //     selectEvent: {
    //         immediate: true,
    //         handler: function() {
    //             if (this.selectEvent) {
    //                 this.disableClass = false
    //                 this.$store.state.main.fullBalance += parseFloat(this.getPrice)
    //                 this.$store.state.main.zero = false
    //             } else {
    //                 this.disableClass = true
    //                 this.$store.state.main.fullBalance -= parseFloat(this.getPrice)
    //                 if (this.$store.state.main.fullBalance < 1) {
    //                     this.$store.state.main.zero = true
    //                 }
    //             }
    //         }
    //     }
    // },
    methods: {
        selectEvent(e) {
            if (e) {
                this.disableClass = false
                this.$store.state.main.fullBalance += parseFloat(this.getPrice)
                this.$store.state.main.zero = false
            } else {
                this.disableClass = true
                this.$store.state.main.fullBalance -= parseFloat(this.getPrice)
                if (this.$store.state.main.fullBalance < 1) {
                    this.$store.state.main.zero = true
                }
            }
        },
        deleteItem(id, val, staticVal) {
            this.productClone = this.productClone.filter(el => el.ProductObject.id !== id)
            this.$store.state.main.cart = this.productClone
            var getPr = JSON.parse(localStorage.getItem('Product'))
            getPr = getPr.filter(el => el.ProductObject.id !== id)
            this.hideClass = true
            this.$store.state.main.fullBalance -= this.getPrice
            localStorage.setItem('Product', JSON.stringify(getPr))
            if (this.$store.state.main.fullBalance < 1) {
                this.$store.state.main.zero = true
            }
        },
        // emitBalance(val, staticVal, minus, mount, staticMount) {
        //     this.$emit('emit-balance', val, staticVal, minus, mount, staticMount)
        // },
        increment() {
            this.incrementChange = true
            this.mount++
            this.$store.state.main.fullBalance += parseFloat(this.getStaitcPrice)
            var res
            res = this.productClone.find(el => el.ProductObject.id === _.get(this.currentData, 'ProductObject.id'))
            res.mount++
            this.productClone.forEach(function(item) {
                if (item.ProductObject.id === res.ProductObject.id) {
                    item = res
                }
            })
            this.$store.state.main.cart = this.productClone
            localStorage.setItem('Product', JSON.stringify(this.productClone))
            // this.emitBalance(this.getPrice, this.getStaitcPrice, false, this.mount, this.staticMount,)
        },
        dencrement() {
            if (this.mount !== 1) {
                this.incrementChange = null
                this.mount--
                this.$store.state.main.fullBalance -= parseFloat(this.getStaitcPrice)
                var res
                res = this.productClone.find(el => el.ProductObject.id === _.get(this.currentData, 'ProductObject.id'))
                res.mount--
                this.productClone.forEach(function(item) {
                    if (item.ProductObject.id === res.ProductObject.id) {
                        item = res
                    }
                })
                this.$store.state.main.cart = this.productClone
                localStorage.setItem('Product', JSON.stringify(this.productClone))
                // this.emitBalance(this.getPrice, this.getStaitcPrice, true, this.mount, this.staticMount)
            }
        }
    }
}
</script>

<style scoped>
.hideClass {
    display: none !important;
}

.disableClass {
    opacity: 0.5;
    pointer-events: none;
}
/* @keyframes delete-anim {
    from {
        opacity: 1;
        transform: translateX(0px);
    }
    to {
        opacity: 0;
        transform: translateX(-10px);
    }
} */

</style>